import { Text } from '@requity-homes/component-library';
import { HOME_SHOPPING_FAQs } from '../../const';

export const FaqTwoContent = () => (
  <div className="flex flex-col gap-2 ml-2">
    <Text useCase="small">
      <span>1.</span> {HOME_SHOPPING_FAQs.redFlags._1}
    </Text>
    <Text useCase="small">
      <span>2.</span> {HOME_SHOPPING_FAQs.redFlags._2}
    </Text>
    <Text useCase="small">
      <span>3.</span> {HOME_SHOPPING_FAQs.redFlags._3}
    </Text>
    <Text useCase="small">
      <span>4.</span> {HOME_SHOPPING_FAQs.redFlags._4}
    </Text>
    <Text useCase="small">
      <span>5.</span> {HOME_SHOPPING_FAQs.redFlags._5}
    </Text>
    <Text useCase="small">
      <span>6.</span> {HOME_SHOPPING_FAQs.redFlags._6}
    </Text>
  </div>
);
